(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gelsome-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const observed = new WeakSet();
  const fit = (copy) => {
    const label = copy.querySelector('.gs-story__label');
    if (!label || !copy.clientWidth) return;
    label.style.setProperty('--gs-label-fit', '100px');
    const width = label.getBoundingClientRect().width;
    const fontSize = parseFloat(getComputedStyle(label).fontSize);
    if (width) label.style.setProperty('--gs-label-fit', (fontSize * copy.clientWidth / width) + 'px');
  };
  const observer = new ResizeObserver(entries => entries.forEach(entry => fit(entry.target)));
  const init = () => document.querySelectorAll('.gs-story__copy').forEach(copy => {
    if (observed.has(copy)) return;
    observed.add(copy);
    observer.observe(copy);
    fit(copy);
  });
  init();
  document.addEventListener('shopify:section:load', init);
  document.fonts.ready.then(() => document.querySelectorAll('.gs-story__copy').forEach(fit));
})();

  } catch(e) { console.error(e); }
})();
})();
